import { useState } from "react";

import { useAtualizarMedico, useCriarMedico, useMedicos } from "@/hooks/useApi";

export function MedicosPage() {
  const [q, setQ] = useState("");
  const { data, isLoading } = useMedicos(q || undefined);
  const criar = useCriarMedico();
  const atualizar = useAtualizarMedico();
  const [form, setForm] = useState({ nome: "", crm: "", uf_crm: "SP", especialidade: "" });

  const ok = form.nome.trim().length >= 2 && form.crm.trim().length >= 1 && form.uf_crm.length === 2;

  async function handleSubmit() {
    if (!ok) return;
    try {
      await criar.mutateAsync({
        nome: form.nome.trim(),
        crm: form.crm.trim(),
        uf_crm: form.uf_crm,
        especialidade: form.especialidade.trim() || null,
      });
      setForm({ nome: "", crm: "", uf_crm: "SP", especialidade: "" });
    } catch { /* erro via criar.error */ }
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-display text-2xl font-semibold">Médicos</h2>
        <p className="text-sm text-ink-muted">Médicos examinadores — usuários do app ou externos.</p>
      </div>

      <div className="card p-4">
        <h3 className="font-display text-base font-semibold">Novo médico</h3>
        <div className="mt-3 grid grid-cols-2 gap-3 md:grid-cols-5">
          <input className="input col-span-2" placeholder="nome" value={form.nome}
            onChange={(e) => setForm({ ...form, nome: e.target.value })} />
          <input className="input" placeholder="CRM" value={form.crm}
            onChange={(e) => setForm({ ...form, crm: e.target.value })} />
          <input className="input" placeholder="UF" maxLength={2} value={form.uf_crm}
            onChange={(e) => setForm({ ...form, uf_crm: e.target.value.toUpperCase() })} />
          <input className="input" placeholder="especialidade (opc.)" value={form.especialidade}
            onChange={(e) => setForm({ ...form, especialidade: e.target.value })} />
        </div>
        <div className="mt-3">
          <button className="btn-primary" disabled={!ok || criar.isPending} onClick={handleSubmit}>
            {criar.isPending ? "Salvando…" : "Adicionar"}
          </button>
        </div>
        {criar.error ? (
          <p className="mt-2 text-sm text-anarosa">{(criar.error as Error).message}</p>
        ) : null}
      </div>

      <input
        className="input max-w-md"
        placeholder="Buscar por nome ou CRM…"
        value={q}
        onChange={(e) => setQ(e.target.value)}
      />

      {isLoading ? <p className="text-ink-muted">Carregando…</p> : null}
      {data && data.length > 0 ? (
        <div className="card overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-left text-xs uppercase tracking-wider text-ink-muted">
              <tr>
                <th className="px-4 py-3">Nome</th>
                <th className="px-4 py-3">CRM</th>
                <th className="px-4 py-3">Especialidade</th>
                <th className="px-4 py-3">Acesso ao app</th>
                <th className="px-4 py-3"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {data.map((m) => (
                <tr key={m.id} className="hover:bg-gray-50">
                  <td className="px-4 py-2">{m.nome}</td>
                  <td className="px-4 py-2 font-mono text-xs">{m.crm}/{m.uf_crm}</td>
                  <td className="px-4 py-2 text-ink-muted">{m.especialidade ?? "—"}</td>
                  <td className="px-4 py-2">
                    {m.entra_object_id ? (
                      <span className="badge-ativo">usuário</span>
                    ) : (
                      <span className="badge-inativo">externo</span>
                    )}
                  </td>
                  <td className="px-4 py-2 text-right">
                    <button
                      className="btn-secondary px-2 py-1 text-xs"
                      disabled={atualizar.isPending}
                      onClick={() => atualizar.mutate({ id: m.id, patch: { ativo: !m.ativo } })}
                    >
                      {m.ativo ? "Desativar" : "Reativar"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : !isLoading ? (
        <p className="text-sm text-ink-muted">Nenhum médico encontrado.</p>
      ) : null}
    </div>
  );
}
